import axios from "axios";

let axiosInstance;

export const getLoginRedirectPath = () => {
  const t =
    typeof window !== "undefined" &&
    window.localStorage &&
    window.localStorage.getItem("loginType");
  return t === "employee" ? "/login-employee" : "/login";
};

const isOnLoginPage = () => {
  const p = window.location.pathname.toLowerCase();
  return (
    p === "/login" ||
    p === "/login-employee" ||
    p.startsWith("/admin-panel/login")
  );
};

export const refreshAxios = () => {
  axiosInstance = axios.create({
    // baseURL: 'https://some-domain.com/api/',
    // timeout: 1000,
    headers: {
      "x-tenantid-1": "main",
      // ...token ? {'X-Auth-Token': token} : {},
    },
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 403) {
        const code = error.response.data?.code;
        const termsHeader = error.response.headers?.["x-terms-status"];
        if (
          code === "TERMS_NOT_ACCEPTED" ||
          termsHeader === "TERMS_NOT_ACCEPTED"
        ) {
          if (
            window.location.pathname !== "/terms-accept" &&
            !isOnLoginPage()
          ) {
            window.location.href = "/terms-accept";
          }
        }
      }
      if (error.response && error.response.status === 401 && !isOnLoginPage()) {
        window.location.href = getLoginRedirectPath();
      }
      return Promise.reject(error);
    }
  );
};

export const getAxiosInstance = () => {
  return axiosInstance;
};
